import React, { useEffect } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import MainLoading from '../../../../utils/MainLoading';
import { fetchUserProfile } from '../../../../redux/action/userProfile/user-profile';
import { useTranslation } from 'react-i18next';

const DeatilsModal = (props) => {
    const dispatch = useDispatch()
    const user_profile = useSelector(state => state.user_profile)
    const {t} = useTranslation();

    useEffect(() => {
        dispatch(fetchUserProfile(props.id))
    }, [props])

    return (
        <>
            {props.show && (
                <Modal show={props.show}>
                    {user_profile.loading ?
                        <MainLoading />
                    :
                        <>
                            <Modal.Header>
                                <Modal.Title>{t("user information")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span>{t("user name")} : </span><span>{user_profile.user.manager_name}</span></div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span>{t("situation")} : </span><span>{user_profile.user.is_block === 1  ? "بلاک شده است" : "ورود آزاد است"}</span></div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span>{t("username")} : </span><span>{user_profile.user.username}</span></div>

                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span>{t("phone-number")} : </span><span>{user_profile.user.manager_mobile}</span></div>
                                    <div className="mb-3 d-flex align-items-center justify-content-between"><span>{t("email address")} : </span><span>{user_profile.user.email  ? user_profile.user.email : "-"}</span></div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={props.handleClick}>
                                    {t("close")}
                                </Button>
                            </Modal.Footer>
                        </>
                    }
                </Modal>
            )}
        </>
      );

}

export default DeatilsModal

